import { createContext, useContext } from 'react';

interface OverlayModalContextValue {
  close: () => void;
}

export const OverlayModalContext = createContext<
  OverlayModalContextValue | undefined
>(undefined);

export const useModalContext = () => {
  const context = useContext(OverlayModalContext);

  if (!context)
    throw new Error('useOverlayModalContext can only be used inside a Modal');

  return context as OverlayModalContextValue;
};
